
export default function updateHotelsLinks(pageStateId) {
    // Try to grab all external links from the post content
    const allExternalLinks = document.querySelectorAll('a[href]');

    // Grab all hotels.smartertravel.com links
    const hotelsLinks = Array.from(allExternalLinks).filter((link) => link.hostname === 'hotels.smartertravel.com');

    hotelsLinks.forEach((link) => {
      const separator = link.search.length > 0 ? '&' : '?';

      link.setAttribute('href', `${link.href}${separator}wp_page_state_id=${pageStateId}&subscriber=OTA`);
    });
	}

